import { useState, useEffect } from 'react';
import { searchClient, ALGOLIA_INDEX_NAME } from "@/lib/algolia";
import { useToast } from "@/components/ui/use-toast";

export const useBrands = () => {
  const [allBrands, setAllBrands] = useState<string[]>([]);
  const [isLoadingBrands, setIsLoadingBrands] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    const fetchAllBrands = async () => {
      try {
        const index = searchClient.initIndex(ALGOLIA_INDEX_NAME);
        const { facets } = await index.search('', {
          facets: ['p_brand'],
          maxValuesPerFacet: 100,
          hitsPerPage: 0, // We don't need the hits, just the facets
        });
        
        if (facets && facets.p_brand) {
          const uniqueBrands = Object.keys(facets.p_brand).sort((a, b) => a.localeCompare(b));
          console.log("Fetched unique brands from facets:", uniqueBrands);
          setAllBrands(uniqueBrands);
        }
      } catch (error) {
        console.error("Error fetching brands:", error);
        toast({
          title: "Error",
          description: "Failed to fetch brands. Please try again.",
          variant: "destructive",
        });
      } finally {
        setIsLoadingBrands(false);
      }
    };

    fetchAllBrands();
  }, [toast]);

  return { allBrands, isLoadingBrands };
};